import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

const LINKS = [
  { to: "/about-us", key: "nav_about" },
  { to: "/contact-us", key: "nav_contact" },
  { to: "/privacy-policy", key: "nav_privacy" },
  { to: "/terms-of-service", key: "nav_terms" },
];

/** Shared site footer with the corporate and legal links. */
export const SiteFooter = () => {
  const { t } = useI18n();

  return (
    <footer className="border-t border-[#2A2A2A] py-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-12 space-y-6">
        <nav className="flex flex-wrap gap-x-7 gap-y-3">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`footer-link-${l.to.slice(1)}`}
              className="text-[11px] tracking-[0.18em] uppercase text-[#A8A8A8] hover:text-[#D4AF37] transition-colors">
              {t(l.key)}
            </Link>
          ))}
        </nav>
        <div className="flex flex-wrap gap-4 justify-between text-xs text-[#707070] border-t border-[#141414] pt-6">
          <span className="font-mono-accent tracking-[0.2em] uppercase">seleksa.com</span>
          <span>{t("footer_note")}</span>
          <span data-testid="footer-copyright">© {new Date().getFullYear()} Seleksa · Medan, Indonesia</span>
        </div>
      </div>
    </footer>
  );
};
